import { Icon } from '@iconify/react';
import { Button } from '@/components/shadcn/button';
import { Card } from '@/components/shadcn/card';

interface PadelTimerPanelProps {
  display: string;
  running: boolean;
  onReset: () => void;
}

export default function PadelTimerPanel({ display, running, onReset }: PadelTimerPanelProps) {
  return (
    <Card className="mt-3 flex flex-row items-center justify-between rounded-2xl border-0 bg-white px-4 py-4 shadow-[inset_0_0_0_1px_#E0E6ED]">
      <div>
        <p className={`text-4xl font-black ${running ? 'text-[#FC480D]' : 'text-[#0E1726]'}`}>
          {display}
        </p>
        <p className="text-xs text-gray-400">
          {running ? 'Timer sedang berjalan' : 'Timer belum dimulai'}
        </p>
      </div>
      <Button
        type="button"
        variant="secondary"
        size="icon"
        aria-label="Reset timer"
        className="h-10 w-10 rounded-2xl bg-[#F4F5F7] text-gray-600 hover:bg-gray-200"
        onClick={onReset}
      >
        <Icon icon="mdi:refresh" className="h-5 w-5" />
      </Button>
    </Card>
  );
}
